import { Euler } from 'three/src/math/Euler';
import { Quaternion } from 'three/src/math/Quaternion';

import { roundNumber } from '../../roundNumber';

export interface QuaternionTuple {
  type: 'quaternion';
  x: number;
  y: number;
  z: number;
  w: number;
}

function eulerToQuaternion(euler: [number, number, number]): QuaternionTuple {
  const quaternion = new Quaternion().setFromEuler(
    new Euler(euler[0], euler[1], euler[2], 'XYZ')
  );

  return {
    type: 'quaternion',
    x: roundNumber(quaternion.x),
    y: roundNumber(quaternion.y),
    z: roundNumber(quaternion.z),
    w: roundNumber(quaternion.w)
  };
}

export default eulerToQuaternion;
